module.exports = __webpack_public_path__ + "im.f7622393971d94129642.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/im.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/im.svg
// module chunks = styles